import { LOGGER_VERBOSITY_KEY } from '../constans';
import { urlSupport } from '../api';

const LoggingLevel = {
    ERRORS: 1, // not used
    WARNINGS: 2,
    LOG: 3, // not used
    INFO: 4, // not used
    DEBUG: 5
};

const loggingLevel =
    Number(window.localStorage.getItem(LOGGER_VERBOSITY_KEY)) || LoggingLevel.WARNINGS;

export function warn(msg, ...args) {
    if (loggingLevel >= LoggingLevel.WARNINGS)
        window.console.warn('WPH Pixel:', msg, 'See', urlSupport, 'for more information.', ...args);
}

export function debug(...args) {
    if (loggingLevel >= LoggingLevel.DEBUG) window.console.debug('WPH Pixel:', ...args);
}

export default {
    loggingLevel,
    warn,
    debug
};
